<div class="breadcrumbs--page-nav hidden-xs hidden-sm flucelvax_Breadcrumbs d-none">
  <div class="container">
    <p><a [routerLink]="'/'">Home</a><span> &gt; </span><a [routerLink]="'/products'">Products</a><span> &gt; </span><strong>FLUCELVAX®</strong></p>
  </div>
</div>
@if (node2 | async; as item) {
  <div class="adjuvantbasedvideo" id="adjuvantbasedvideo">
    <div class="container col-md-12 col-xs-12" id="productVideo">
      <div class="videocontainer abovewidth">
        <div class="col-md-5 col-xs-12 text_Container">
          <div class="watchtext" [innerHTML]="item.headLine"></div>
          <a [routerLink]="item?.name" class="watchLink">{{item?.textContent}}</a>
          <div class="watchsubtext" [innerHTML]="item.content"></div>
        </div>
        <div class="col-md-7 col-xs-12">
          @if (item?.mediaVideo) {
            <div class="video-wrap" >
              <video muted playsinline [poster]="getVideo(item?.mediaPicture)" controls="" [attr.title]="item?.mediaVideo?.altText">
                <source [src]="getVideo(item?.mediaVideo)" type="video/mp4"/>
              </video>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}